import { Button, Text } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'
import LogoGradientIcon from '../../icons/LogoGradientIcon'

function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="h-screen flex light dark:dark">
      <div className="flex flex-col items-center justify-center text-center w-full gap-8">
        <LogoGradientIcon height="26" width="71" />
        <Text size="9" weight="medium" className="max-w-[650px]">
          The page you’re looking for couldn’t be found
        </Text>
        <Button
          className="max-w-[200px] my-4 w-full rounded cursor-pointer bg-PurpleBlue-9 dark:bg-mainPurple hover:bg-PurpleBlue-10 dark:hover:bg-tertiaryPurple active:bg-PurpleBlue-10 dark:active:bg-tertiaryPurple"
          onClick={() => navigate('/dashboard')}
        >
          Go to Portal
        </Button>
      </div>
    </div>
  )
}

export default NotFound
